import { useRef } from 'react'
import { useLocation } from 'react-router-dom'

const shouldScrollToTop = (previousPathname: string, pathname: string, state: unknown) => {
  const isVisualExplorerTabNavigation = previousPathname !== '' && previousPathname.startsWith('/visual-explorer/') && pathname.startsWith('/visual-explorer/')
  const skipScrollToTopFromState = (state as { skipScrollToTop?: boolean } | null)?.skipScrollToTop === true
  return !isVisualExplorerTabNavigation && !skipScrollToTopFromState
}

/**
 * Resets window scroll position to the top whenever the route pathname changes.
 * Must be rendered inside a Router context, ahead of the routes.
 *
 * The reset happens while rendering rather than in an effect, so it lands before the new page
 * renders. A window virtualizer (GRTable) reads the scroll position when it is created, and one
 * created at the old position scrolls the page back down while measuring its rows.
 */
const ScrollToTop: React.FC = () => {
  const { pathname, state } = useLocation()
  const previousPathnameRef = useRef<string | null>(null)

  if (previousPathnameRef.current !== pathname) {
    const previousPathname = previousPathnameRef.current ?? ''
    previousPathnameRef.current = pathname
    if (shouldScrollToTop(previousPathname, pathname, state)) {
      window.scrollTo(0, 0)
    }
  }

  return null
}

export default ScrollToTop
